// Formato canónico de variaciones porcentuales (MoM/YoY/acumulados).
// Convención del sistema:
//
// - withArrow=true       → prefija una flecha (▲/▼ o ↑/↓ según arrowStyle)
// - arrowStyle="triangle"→ ▲/▼ — denso, lectura analítica (SalesEvolutionTable
//                         acumulado column). Default.
// - arrowStyle="line"    → ↑/↓ — ligero, lectura sobria (KPI tables del modal
//                         de análisis). Mismo glyph que material/feather icons
//                         para que coincida visualmente con el resto del icon
//                         system del modal.
// - withSign=true        → prefija + para positivos (negativos SIEMPRE llevan
//                         "-" — color solo no es suficiente para accesibilidad)
// - ratio = 0            → siempre "0%" (sin arrow, sin sign)
// - ratio = null         → cae al sentinel `dash` (default "—")
// - Formato: porcentaje entero (redondeo half-up), sin decimales.
const ARROWS = {
    triangle: { up: "▲ ", down: "▼ " },
    line: { up: "↑ ", down: "↓ " },
};

export function formatVariation(ratio, options = {}) {
    const {
        withArrow = false,
        arrowStyle = "triangle",
        withSign = false,
        dash = "—",
    } = options;

    if (ratio == null) return dash;
    if (ratio === 0) return "0%";

    const arrows = ARROWS[arrowStyle] ?? ARROWS.triangle;
    const arrow = withArrow ? (ratio > 0 ? arrows.up : arrows.down) : "";
    let signPrefix = "";
    if (ratio < 0) signPrefix = "-";
    else if (withSign) signPrefix = "+";

    const value = Math.round(Math.abs(ratio) * 100);
    return `${arrow}${signPrefix}${value}%`;
}
